import { Fragment, Children, isValidElement, cloneElement } from 'react';

//ΔVΔVΔ: Helper fn, check to see if a variable is <></>
const isReactFragment = (variableToInspect) => {
    if (variableToInspect?.type) {
        return variableToInspect.type === Fragment;
    }
    return variableToInspect === Fragment;
};
export { isReactFragment };

//ΔVΔVΔ: A Props filter is used when adding props to children,
//a function must have the following arguments: index,child,props and must return a props object
//by default it will return the original unaltered props
// the purpose of this filter is to be able to alter the props based on the child ID or child object
const defaultPropsFilter = (index, child, props) => {
    //example of use
    // props.logMe = (id) => {
    //     console.log(id, child);
    // };
    return props;
};
const addPropsToChildren = (children, props) => {
    const { startIndex = 0, prefix = '', suffix = '', propsFilter = defaultPropsFilter, ...rest } = props;

    var grandKidsInd = 0;
    return Children.map(children, (child, index) => {
        let adjustedIndex = startIndex + index + grandKidsInd;
        if (isReactFragment(child)) {
            var grandChildren = addPropsToChildren(child.props.children, { ...props, startIndex: adjustedIndex });
            grandKidsInd = grandChildren[grandChildren.length - 1].props.index;
            return <>{grandChildren}</>;
        }
        if (isValidElement(child)) {
            let id = prefix + index + suffix;
            let adjustedProps = propsFilter(adjustedIndex, child, { id, ...rest });
            return cloneElement(child, { index: adjustedIndex, ...adjustedProps });
        }
        return child;
    });
};
export { addPropsToChildren };
